export default __webpack_public_path__ + "img/9.f1b6fc.png";